// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_context.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { ProposalContextAdoption, ProposalContextCandidate, ProposalContextReview, ProposalContextWording, ProposalStaffingMapping } from "../../datagateway/v1/proposal_context_pb";
/**
 * Authorization-only callback used by pangaea; returns no project/source data.
 *
 * @generated from message mono.projectdata.v1.CheckProposalContextAccessRequest
 */ export class CheckProposalContextAccessRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckProposalContextAccessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckProposalContextAccessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckProposalContextAccessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckProposalContextAccessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: bool write = 3;
   */ _define_property(this, "write", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckProposalContextAccessRequest, "runtime", proto3);
_define_property(CheckProposalContextAccessRequest, "typeName", "mono.projectdata.v1.CheckProposalContextAccessRequest");
_define_property(CheckProposalContextAccessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CheckProposalContextAccessResponse
 */ export class CheckProposalContextAccessResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckProposalContextAccessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckProposalContextAccessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckProposalContextAccessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckProposalContextAccessResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckProposalContextAccessResponse, "runtime", proto3);
_define_property(CheckProposalContextAccessResponse, "typeName", "mono.projectdata.v1.CheckProposalContextAccessResponse");
_define_property(CheckProposalContextAccessResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.AdoptProposalContextRequest
 */ export class AdoptProposalContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdoptProposalContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptProposalContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptProposalContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptProposalContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * solution | win_theme | output; solution identity is the canonical Pursuit ID.
   *
   * @generated from field: string source_kind = 3;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 4;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string source_version_id = 5;
   */ _define_property(this, "sourceVersionId", ""), /**
   * Required for output: existing OUT-07 baseline, never created implicitly.
   *
   * @generated from field: string handoff_id = 6;
   */ _define_property(this, "handoffId", ""), /**
   * Explicit snapshot | live; omission is invalid.
   *
   * @generated from field: string mode = 7;
   */ _define_property(this, "mode", ""), /**
   * @generated from field: repeated string section_keys = 8;
   */ _define_property(this, "sectionKeys", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptProposalContextRequest, "runtime", proto3);
_define_property(AdoptProposalContextRequest, "typeName", "mono.projectdata.v1.AdoptProposalContextRequest");
_define_property(AdoptProposalContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "handoff_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "section_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProposalContextRequest
 */ export class GetProposalContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string adoption_id = 2;
   */ _define_property(this, "adoptionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalContextRequest, "runtime", proto3);
_define_property(GetProposalContextRequest, "typeName", "mono.projectdata.v1.GetProposalContextRequest");
_define_property(GetProposalContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalContextsRequest
 */ export class ListProposalContextsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalContextsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalContextsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalContextsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalContextsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalContextsRequest, "runtime", proto3);
_define_property(ListProposalContextsRequest, "typeName", "mono.projectdata.v1.ListProposalContextsRequest");
_define_property(ListProposalContextsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalContextCandidatesRequest
 */ export class ListProposalContextCandidatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalContextCandidatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalContextCandidatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalContextCandidatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalContextCandidatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalContextCandidatesRequest, "runtime", proto3);
_define_property(ListProposalContextCandidatesRequest, "typeName", "mono.projectdata.v1.ListProposalContextCandidatesRequest");
_define_property(ListProposalContextCandidatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AdoptProposalContextResponse
 */ export class AdoptProposalContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdoptProposalContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptProposalContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptProposalContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptProposalContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalContextAdoption adoption = 1;
   */ _define_property(this, "adoption", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptProposalContextResponse, "runtime", proto3);
_define_property(AdoptProposalContextResponse, "typeName", "mono.projectdata.v1.AdoptProposalContextResponse");
_define_property(AdoptProposalContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption",
            kind: "message",
            T: ProposalContextAdoption
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProposalContextResponse
 */ export class GetProposalContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalContextAdoption adoption = 1;
   */ _define_property(this, "adoption", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalContextResponse, "runtime", proto3);
_define_property(GetProposalContextResponse, "typeName", "mono.projectdata.v1.GetProposalContextResponse");
_define_property(GetProposalContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption",
            kind: "message",
            T: ProposalContextAdoption
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalContextsResponse
 */ export class ListProposalContextsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalContextsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalContextsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalContextsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalContextsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalContextAdoption adoptions = 1;
   */ _define_property(this, "adoptions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalContextsResponse, "runtime", proto3);
_define_property(ListProposalContextsResponse, "typeName", "mono.projectdata.v1.ListProposalContextsResponse");
_define_property(ListProposalContextsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoptions",
            kind: "message",
            T: ProposalContextAdoption,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalContextCandidatesResponse
 */ export class ListProposalContextCandidatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalContextCandidatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalContextCandidatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalContextCandidatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalContextCandidatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalContextCandidate candidates = 1;
   */ _define_property(this, "candidates", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalContextCandidatesResponse, "runtime", proto3);
_define_property(ListProposalContextCandidatesResponse, "typeName", "mono.projectdata.v1.ListProposalContextCandidatesResponse");
_define_property(ListProposalContextCandidatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidates",
            kind: "message",
            T: ProposalContextCandidate,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProposalContextReviewRequest
 */ export class GetProposalContextReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalContextReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalContextReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalContextReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalContextReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string adoption_id = 2;
   */ _define_property(this, "adoptionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalContextReviewRequest, "runtime", proto3);
_define_property(GetProposalContextReviewRequest, "typeName", "mono.projectdata.v1.GetProposalContextReviewRequest");
_define_property(GetProposalContextReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProposalContextReviewResponse
 */ export class GetProposalContextReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalContextReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalContextReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalContextReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalContextReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalContextReview review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalContextReviewResponse, "runtime", proto3);
_define_property(GetProposalContextReviewResponse, "typeName", "mono.projectdata.v1.GetProposalContextReviewResponse");
_define_property(GetProposalContextReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ProposalContextReview
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideProposalContextRequest
 */ export class DecideProposalContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideProposalContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideProposalContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideProposalContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideProposalContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string adoption_id = 2;
   */ _define_property(this, "adoptionId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string expected_decision_id = 4;
   */ _define_property(this, "expectedDecisionId", ""), /**
   * @generated from field: string expected_upstream_version_id = 5;
   */ _define_property(this, "expectedUpstreamVersionId", ""), /**
   * @generated from field: string action = 6;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string basis = 7;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalContextWording wording = 8;
   */ _define_property(this, "wording", []), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalStaffingMapping mappings = 9;
   */ _define_property(this, "mappings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideProposalContextRequest, "runtime", proto3);
_define_property(DecideProposalContextRequest, "typeName", "mono.projectdata.v1.DecideProposalContextRequest");
_define_property(DecideProposalContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_decision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_upstream_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "wording",
            kind: "message",
            T: ProposalContextWording,
            repeated: true
        },
        {
            no: 9,
            name: "mappings",
            kind: "message",
            T: ProposalStaffingMapping,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideProposalContextResponse
 */ export class DecideProposalContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideProposalContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideProposalContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideProposalContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideProposalContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalContextReview review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideProposalContextResponse, "runtime", proto3);
_define_property(DecideProposalContextResponse, "typeName", "mono.projectdata.v1.DecideProposalContextResponse");
_define_property(DecideProposalContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ProposalContextReview
        }
    ]));
